// extracted by mini-css-extract-plugin
export default {"form":"Form-module__form___fUykO","input":"Form-module__input___mDyy5","searchButton":"Form-module__searchButton___WDphC","active":"Form-module__active___FjT0B"};